import { z } from 'zod';
import { emailSchema } from './auth';
import { schoolGroupSchema, timestampSchema } from './common';

export const TEST_ACCOUNT_DAYS = 365;

const nameField = z
  .string()
  .trim()
  .max(80)
  .nullable()
  .transform((value) => (value === '' ? null : value));

const noteField = z.string().trim().max(500);

export const testAccountChildInputSchema = z.object({
  firstName: z.string().trim().min(1).max(40),
  schoolGroup: schoolGroupSchema,
});

export const testAccountInputSchema = z.object({
  email: emailSchema,
  name: nameField.default(null),
  until: z.iso.date(),
  note: noteField.default(''),
  children: z.array(testAccountChildInputSchema).max(6).default([]),
  sendInvite: z.boolean().default(true),
});

export const testAccountUpdateSchema = z.object({
  email: emailSchema,
  name: nameField,
  until: z.iso.date(),
  note: noteField,
});

export const testAccountSchema = z.object({
  id: z.uuid(),
  email: z.string(),
  name: z.string().nullable(),
  note: z.string(),
  until: timestampSchema.nullable(),
  active: z.boolean(),
  children: z.array(z.object({ firstName: z.string(), schoolGroup: schoolGroupSchema })),
  createdAt: timestampSchema,
  lastLoginAt: timestampSchema.nullable(),
  invitedAt: timestampSchema.nullable(),
  createdBy: z.string().nullable(),
});

export const testAccountListSchema = z.object({ accounts: z.array(testAccountSchema) });

export type TestAccountInput = z.input<typeof testAccountInputSchema>;
export type TestAccountFields = z.output<typeof testAccountInputSchema>;
export type TestAccountUpdate = z.infer<typeof testAccountUpdateSchema>;
export type TestAccount = z.infer<typeof testAccountSchema>;
export type TestAccountList = z.infer<typeof testAccountListSchema>;
